<template>
  <div>

    <Head />
    <div class="layout">
      <div class="aboutUs">
        <!-- 头部 -->
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p>持之以恒 &nbsp; 事在人为</p>
            </div>
            <div class="right">
              <img
                src="../../assets/images/pc/aboutUs/part1.png"
                alt
              />
            </div>

          </div>
        </div>
        <!-- 公司简介 -->
        <div class="part-2">
          <div class="main">
            <p class="tit">{{$t('aboutUs.part2.tit')}}</p>
            <p class="text1 text">江苏恒为信息科技有限公司(以下称为“恒为信息科技”) 是全国区块链和分布式记账技术标准化技术委员会(SAC/TC590)委员单位、江苏省区块链标准化技术委员会(JS-TC63)委员单位，中国区块链技术和产业发展论坛理事单位、可信区块链推进计划会员单位、江苏省区块链发展协会副理事长单位、无锡市区块链产业联盟会长单位。</p>
            <p class="text1 text">恒为信息科技是由海归学子创建的一家专注于区块链底层技术研发及产业应用部署的江苏省高新技术企业，无锡市专精特新企业，公司于2015年成立于无锡高新区，已通过ISO、ITSS，知识产权贯标等多项国家认证。恒为信息科技积极与大院大所及高校开展战略合作，内容包括区块链底层技研发及服务、区块链技术标准及测评，行业应用生态建设等。</p>
            <p class="text1 text">恒为信息科技发展至今成果斐然，参与编写了区块链国家标准1项和团体标准7项，牵头起草地方标准2项，参与编写国内首部《中国区块链与物联网融合创新应用蓝皮书》、《区块链应用操作员国家职业技术技能标准》，参与编写《区块链领导干部读本》、《江苏省工业区块链应用发展白皮书》、《无锡市政务区块链创新应用指南》、《江苏省区块链产业发展报告》、《江苏省工业区块链应用发展白皮书》、《无锡数字经济发展报告》等，2024年连续三年入选国家“产业区块链企业50强”，是无锡市区块链产业核心企业。</p>
          </div>
        </div>
        <!-- 恒为信息 -->
        <div class="part-3">
          <div class="main">
            <p class="tit">{{$t('aboutUs.part6.tit')}}</p>
            <p class="text text1">{{$t('aboutUs.part6.text1')}}</p>
            <p class="text">{{$t('aboutUs.part6.text2')}}</p>
          </div>
        </div>
        <!-- 发展历程 -->
        <div class="part-4">
          <div class="main">
            <p class="tit">发展历程</p>
            <div class="year-wrap">
              <span
                class="arrow arrow-left"
                :class="{ disabled: !canScrollLeft }"
                @click="canScrollLeft && scrollYear(-1)"
              ><</span>
              <div class="year" ref="yearScroll" @scroll="updateScrollState">
                <span
                  v-for="(item, index) in historyList"
                  :key="index"
                  :ref="'yearItem-' + item.year"
                  :class="year == item.year ? 'blue':''"
                  @click="selectYear(item.year)"
                >{{ item.year }}</span>
              </div>
              <span
                class="arrow arrow-right"
                :class="{ disabled: !canScrollRight }"
                @click="canScrollRight && scrollYear(1)"
              >></span>
            </div>
            <div
              class="text"
              v-for="(item, index) in historyList"
              :key="'t-'+index"
              v-show="year == item.year"
            >
              <p v-for="(info, i) in item.list" :key="i">
                <span class="time">{{ info.time }}</span>
                <span class="str">{{ info.str }}</span>
              </p>
            </div>
          </div>
        </div>
        <!-- 公司荣誉 -->
        <div class="part-5">
          <div class="main">
            <p class="tit">{{$t('aboutUs.part3.tit')}}</p>
            <div class="l">
              <img
                src="../../assets/images/pc/aboutUs/part5-1.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-2.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-3.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-4.png"
                alt
              />
            </div>
            <div class="l l2">
              <img
                src="../../assets/images/pc/aboutUs/part5-5.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-6.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-7.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-8.png"
                alt
              />
            </div>
          </div>
        </div>
        <!-- 联系我们 -->
        <div class="part-6">
          <div class="main">
            <div class="content">
              <div class="left">
                <p class="tit">{{$t('aboutUs.part4.tit')}}</p>
                <div class="text">
                  <div class="tel info">
                    <p class="iconfont icondianhua p1"></p>
                    <p class="p2"> 固定电话：0510-85386599</p>
                  </div>
                  <div class="emails info">
                    <p class="iconfont iconxinfeng p1"></p>
                    <div class="email">
                      <p>{{$t('aboutUs.part4.email1')}}： service@hwelltech.com</p>
                      <p>{{$t('aboutUs.part4.email2')}}： marketing@hwelltech.com</p>
                      <p>{{$t('aboutUs.part4.email3')}}： blockchain@hwelltech.com</p>
                    </div>
                  </div>
                  <div class="add info">
                    <p class="iconfont icondingwei p1"></p>
                    <p class="p2">{{$t('aboutUs.part4.add')}}</p>
                  </div>

                </div>
              </div>
              <div class="img">
                <img
                  src="../../assets/images/pc/aboutUs/part6.png"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/pc/Head";
import Foot from "../../components/pc/Foot";
export default {
  name: "aboutUs",
  components: {
    Head,
    Foot,
  },
  data() {
    return {
      cn: false,
      en: false,
      y: 19,
      year: 2026,
      canScrollLeft: false,
      canScrollRight: false,
      resizeObserver: null,
      historyList: [
        {
          year: 2015,
          list: [
            { time: "2015", str: "公司成立" },
          ],
        },
        {
          year: 2016,
          list: [
            { time: "2016", str: "参加物博会" },
          ],
        },
        {
          year: 2017,
          list: [
            { time: "2017/05/12", str: "成立物联网+区块链联合实验室并发布行动计划" },
            { time: "2017/08", str: "发布《中国区块链与物联网融合创新应用蓝皮书》" },
            { time: "2017/12/22", str: "通过中国电子标准化研究院区块链系统技术测评" },
            { time: "2017/12", str: "《中国区块链与物联网融合创新应用蓝皮书》的发布荣获\"2017年度无锡市软件和信息服务业（企业）\"十大最具影响力事件" },
          ],
        },
        {
          year: 2018,
          list: [
            { time: "2018/09/17", str: "承办2018世界物联网大会区块链与物联网融合发展峰会" },
          ],
        },
        {
          year: 2019,
          list: [
            { time: "2019/04/17", str: "启动国内首部物联网与区块链融合地方标准的编制" },
            { time: "2019/08", str: "成为中国区块链技术和产业发展论坛理事成员" },
            { time: "2019/10/18", str: "\"恒为链\"成功通过境内区块链信息服务备案" },
          ],
        },
        {
          year: 2020,
          list: [
            { time: "2020/05", str: "恒为信息科技成为第一届SACTC590《全国区块链和分布式记账技术标准化技术委员会》成员单位" },
            { time: "2020/06", str: "恒为信息科技在江苏省工信厅，无锡市政府，无锡市网信办，无锡市工信局的指导下发起成立无锡市区块链产业联盟，恒为信息科技成为首届会长单位" },
            { time: "2020/12", str: "恒为信息科技通过质量管理体系（ISO9001）、信息安全管理体系（ISO27001）、ITSS软件运维服务体系等多项认证" },
            { time: "2020/12", str: "恒为信息科技中标承建“区块链+三资监管”项目" },
          ],
        },
        {
          year: 2021,
          list: [
            { time: "2021/09", str: "恒为信息科技支撑无锡市新吴区（高新区）工信局申报\"新吴区争创江苏省区块链产业发展集聚区\"工作，并于2021年12月成功入选江苏省区块链产业发展集聚区" },
            { time: "2021/11", str: "恒为信息科技支撑中共无锡市委网信办完成\"无锡市人民政府争创国家区块链创新应用试点（综合）\"申报工作，并于2022年1月成功入选国家区块链创新应用试点（综合）城市" },
            { time: "2021/12", str: "恒为信息科技\"高性能安全自主可控的区块链底层服务平台\"、\"基于区块链技术的政务数据治理网关\"荣获无锡市区块链应用项目优秀案例奖" },
            { time: "2021/12", str: "恒为信息科技承办\"链上未来——区块链安全发展和产业创新论坛\"" },
          ],
        },
        {
          year: 2022,
          list: [
            { time: "2022/06", str: "恒为信息科技担任江苏省区块链产业发展协会副理事长单位" },
            { time: "2022/07", str: "恒为信息科技入选中国\"产业区块链100强企业\"" },
            { time: "2022/07", str: "恒为信息科技\"自主安全可控的高性能区块链BaaS服务平台\"项目入围\"2022年江苏省区块链产业发展试点示范项目名单\"" },
            { time: "2022/09", str: "恒为信息科技入选JC/TC63江苏省区块链标准化技术委员会单位" },
            { time: "2022/12", str: "恒为信息科技新增7个区块链项目成功备案" },
          ],
        },
        {
          year: 2023,
          list: [
            { time: "2023/05", str: "恒为信息科技承建无锡市\"太湖链\"管理服务平台，支撑30个政务应用上链，支撑国家区块链创新应用试点城市建设" },
            { time: "2023/05", str: "恒为信息科技承接无锡市财政局，无锡市纪委监委牵头建设的无锡市镇（街）国有资产监管项目，并上升到全省试点" },
            { time: "2023/08", str: "恒为信息科技入选中国\"产业区块链100强企业\"" },
            { time: "2023/09", str: "恒为信息科技推动并参与无锡市高新区（新吴区）政府与中国电子技术标准化研究院合作建设的省级区块链测评中心" },
          ],
        },
        {
          year: 2024,
          list: [
            { time: "2024/06", str: "恒为信息科技承建的无锡市\"太湖链\"管理服务平台荣获2024江苏省优秀解决方案二等奖" },
            { time: "2024/06", str: "恒为信息科技承担无锡市政府举办的\"链上无锡\"区块链创新应用成果展现场解说" },
            { time: "2024/10", str: "恒为信息科技入选全国\"产业区块链企业50强\"" },
            { time: "2024/10", str: "恒为信息科技与中国电子技术标准化研究院共同建设无锡市高新区（新吴区）区块链测评中心" },
          ],
        },
        {
          year: 2025,
          list: [
            { time: "2025/05", str: "恒为信息科技积极与香港稳定币持牌机构建立战略合作伙伴关系，围绕稳定币跨境贸易支付结算、RWA（实物资产代币化）业务拓展开展合作，推动无锡相关能源企业开展绿色算力资产化RWA项目落地工作" },
            { time: "2025/09", str: "恒为信息科技做为技术支撑公司，派代表专家出席\"第七届长三角区块链应用创新大赛\"，开展\"新科技金融组\"项目复赛评审工作" },
            { time: "2025/11", str: "恒为信息科技积极响应无锡市人民政府办公室发布关于印发《无锡市中小企业数字化转型试点城市建设工作方案》的通知要求，推动10家以上企业探索运用区块链技术，打造多主体的供应链可信协同机制、可信可控的安全生产机制、产品全生命周期质量机制" },
          ],
        },
        {
          year: 2026,
          list: [
            { time: "2026/04", str: "恒为信息科技依托香港Web3产业集聚、国际规则接轨优势，与香港Web3协会达成深度生态战略合作伙伴关系，围绕区块链、Web3领域标准编制、规则共建、国际对标三大方向开展深度交流合作" },
            { time: "2026/06", str: "恒为信息科技依托香港合规持牌平台，启动区块链技术在场景支付、跨境清算结算领域试点落地工作，实现技术+合规+场景的全链路数据经济发展生态" },
          ],
        },
      ],
    };
  },
  mounted() {
    this.mobile();
    this.$nextTick(() => {
      this.selectYear(this.year);
      this.updateScrollState();
      this.initResizeObserver();
      window.addEventListener('resize', this.updateScrollState);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollState);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  created() {
    this.getLang();
  },

  methods: {
    initResizeObserver() {
      const container = this.$refs.yearScroll;
      if (!container) return;
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => {
          this.updateScrollState();
        });
        this.resizeObserver.observe(container);
      }
    },
    updateScrollState() {
      const container = this.$refs.yearScroll;
      if (!container) return;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      this.canScrollLeft = container.scrollLeft > 0;
      this.canScrollRight = container.scrollLeft < maxScrollLeft;
    },
    scrollYear(direction) {
      const container = this.$refs.yearScroll;
      if (!container) return;
      const scrollAmount = container.clientWidth * 0.8;
      const target = container.scrollLeft + direction * scrollAmount;
      const maxScroll = container.scrollWidth - container.clientWidth;
      const clamped = Math.max(0, Math.min(maxScroll, target));
      container.scrollTo({
        left: clamped,
        behavior: 'smooth',
      });
      setTimeout(() => {
        this.updateScrollState();
      }, 400);
    },
    selectYear(year) {
      this.year = year;
      this.$nextTick(() => {
        const ref = this.$refs['yearItem-' + year];
        if (ref && ref[0]) {
          const el = ref[0];
          const container = this.$refs.yearScroll;
          const elLeft = el.offsetLeft;
          const elWidth = el.offsetWidth;
          const containerWidth = container.clientWidth;
          const maxScroll = container.scrollWidth - container.clientWidth;
          let targetScrollLeft = elLeft - (containerWidth - elWidth) / 2;
          targetScrollLeft = Math.max(0, Math.min(maxScroll, targetScrollLeft));
          container.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth',
          });
          setTimeout(() => {
            this.updateScrollState();
          }, 400);
        }
      });
    },
    getLang() {
      var lang;
      if (this.$i18n.locale == "en") {
        this.en = true;
        this.lang = "en";
      } else {
        this.cn = true;
        this.lang = "cn";
      }
    },
    mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if ((flag && flag.length) > 0) {
        this.$router.replace("/mobile" + this.$route.path);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  min-width: @min-width;
  background-color: #f8f9fb;
}
.aboutUs {
  background: #fff;
  .part-1 {
    margin-top: 70px;
    height: 511px;
    width: 100%;
    .bg(@url:url("../../assets/images/pc/aboutUs/part1-bg.png"));
    background-size: auto 511px;
    .main {
      padding: 0;
      .left {
        float: left;
        padding-top: 218px;
        padding-left: 40px;
        p {
          font-size: 40px;
          color: #fff;
          line-height: 40px;
        }
      }
      .right {
        width: 50%;
        float: left;

        img {
          width: 919px;
          height: 466px;
          margin: 45px 0 0 178px;

          @media screen and(min-width: 1366px) {
          }
          @media screen and(max-width: 1366px) {
          }
        }
      }
    }
  }
  .part-2 {
    background: #fff;
    padding: 80px 0 70px;

    .main {
      padding: 0;
      .tit {
        .onlyTit();
      }

      .text {
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        text-indent: 28px;
      }
      .text1 {
        margin-bottom: 20px;
      }
    }
  }
  .part-3 {
    padding: 80px 0 70px;
    .bg(@url: url("../../assets/images/pc/aboutUs/part3-bg.png"));
    background-size: auto 100%;
    .main {
      padding: 0;
      .tit {
        .onlyTit();
        color: #fff;
      }
      .text {
        font-size: 14px;
        color: #fff;
        line-height: 24px;
        text-indent: 28px;
      }
      .text1 {
        margin-bottom: 20px;
      }
    }
  }
  .part-4 {
    padding: 80px 0;
    background: #f9f9f9;
    .main {
      padding: 0;
      .tit {
        .onlyTit();
      }
      .year-wrap {
        position: relative;
        display: flex;
        align-items: center;
      }
      .arrow {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 52px;
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        color: #2a93ff;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
        user-select: none;
        flex-shrink: 0;
        &:hover {
          background: #f0f7ff;
        }
      }
      .arrow-left {
        border-radius: 4px 0 0 4px;
      }
      .arrow-right {
        border-radius: 0 4px 4px 0;
      }
      .arrow.disabled {
        color: #c0c0c0;
        cursor: not-allowed;
        &:hover {
          background: #fff;
        }
      }
      .year {
        flex: 1;
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        height: 52px;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
        span {
          display: inline-block;
          width: 110px;
          margin: 0 40px;
          font-size: 14px;
          line-height: 53px;
          height: 100%;
          color: #2a93ff;
          cursor: pointer;
          text-align: center;
          position: relative;
          &:hover {
            .blue();
          }
        }
        .blue {
          .blue();
        }
      }
      .text {
        margin: 27px auto 0;
        width: 936px;
        // height: 250px;
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        padding: 55px 167px;
        p {
          display: flex;
          margin-bottom: 10px;
          span {
            display: inline-block;
            font-size: 14px;
            line-height: 24px;
          }
          .time {
            width: 76px;
            margin-right: 18px;
          }
          .str {
            width: 494px;
          }
        }
        p:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
  }
  .part-5 {
    padding: 80px 0 70px;
    background: #ffffff;
    .main {
      padding: 0;
      .tit {
        .onlyTit();
      }
      .l {
        width: 100%;
        display: flex;
        img {
          width: 283px;
         
          margin: 0 4px;
        }
      }
      .l{
        img{
          height: 391px;
        }
      }
      .l2{
        img{
          height: 205px;
        }
      }
    }
  }

  .part-6 {
    height: 522px;
    .bg(@url: url("../../assets/images/pc/aboutUs/part6-bg.png"));
    background-size: auto 522px;

    // @media screen and(max-width: 1366px) {
    // background-image: url("../../assets/images/pc/aboutUs/part4-bg2-new.png");
    // background-size: 100% 100%;
    // }
    .main {
      padding: 0;
      height: 100%;
      padding-top: 89px;
      .content {
        background-color: #fff;

        margin-left: 490px;
        // @media screen and(max-width: 1366px) {
        // margin-left: 53%;
        // }
        padding: 61px 31px 49px 37px;
        width: 521px;
        display: flex;
        .left {
          width: 299px;

          .tit {
            margin-bottom: 31px;
            font-size: 24px;
            color: #444444;
            line-height: 24px;
          }
          .text {
            width: 100%;
            .info {
              width: 100%;
              display: flex;
              .p1 {
                width: 18px;
                margin-right: 10px;
                display: inline-block;
                font-size: 18px;
                position: relative;
                top: -3px;
              }
              .p2 {
                width: 317px;
                font-size: 14px;
                color: #444444;
              }
            }
            .tel {
              margin-bottom: 25px;
            }
            .emails {
              margin-bottom: 25px;
              .email {
                p {
                  font-size: 14px;
                  color: #444444;
                }
              }
            }
            .add {
            }
          }
        }
        .img {
          margin: 45px 0 0 12px;

          img {
            width: 130px;
            height: 130px;
          }
        }
      }
    }
    /deep/.iconfont {
      color: #3a88f7;
    }
  }
}
</style>